import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function AnimationToScroll(props) {
  const slideInTop = (elem, delay, duration) => {
    gsap.fromTo(
      elem,
      {
        opacity: 0,
        y: -200,
      },
      {
        opacity: 1,
        y: 0,
        delay: delay || 0.4,
        duration: duration || 0.6,
        scrollTrigger: {
          trigger: elem,
          start: "top center",
          end: "bottom center",
        },
      }
    );
  };

  const slideInLeft = (elem, delay, duration) => {
    gsap.fromTo(
      elem,
      {
        opacity: 0,
        x: -200,
      },
      {
        opacity: 1,
        x: 0,
        delay: delay || 0.4,
        duration: duration || 0.6,
        scrollTrigger: {
          trigger: elem,
          start: "top center",
          end: "bottom center",
        },
      }
    );
  };

  // Animation du texte au niveau du header
  const onLoad = () => {
    gsap.timeline().fromTo(
      ".text",
      {
        x: -100,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
        stagger: 0.15,
        delay: 0.7,
      }
    );
    // .to(window, {
    //     duration: 3,
    //     scrollTo: '.nextSection'
    // })
  };

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    slideInTop(".box1");
  }, []);

  useEffect(() => {
    slideInLeft(".box2");
  }, []);

  useEffect(() => {
    slideInTop(".box3");
  }, []);

  useEffect(() => {
    slideInLeft(".box4");
  }, []);

  useEffect(() => {
    slideInTop(".box5");
  }, []);
}

export default AnimationToScroll;
